export const HOMOLOGACAO = 'HOMOLOGACAO';
export const HOMOLOGACAO_START = 'HOMOLOGACAO_START';
export const HOMOLOGACAO_SUCCESS = 'HOMOLOGACAO_SUCCESS';
export const HOMOLOGACAO_ERROR = 'HOMOLOGACAO_ERROR';

export const HOMOLOGACAO_ARQUIVOS = 'HOMOLOGACAO_ARQUIVOS';
export const HOMOLOGACAO_ARQUIVOS_START = 'HOMOLOGACAO_ARQUIVOS_START';
export const HOMOLOGACAO_ARQUIVOS_SUCCESS = 'HOMOLOGACAO_ARQUIVOS_SUCCESS';
export const HOMOLOGACAO_ARQUIVOS_ERROR = 'HOMOLOGACAO_ARQUIVOS_ERROR';
